export const setEntityType = (entity) =>  localStorage.setItem("__entity-type", entity);
export const defineEntityType = () => localStorage.getItem("__entity-type");
export const resetEntityType = () => localStorage.removeItem("__entity-type");
